import { useWalletModalToggle } from "state/application/hooks"

const ConnectWallet = () => {
  const toggleWalletModal = useWalletModalToggle()

  return (
    <div className="absolute top-0 right-0 left-0 bottom-0" data-testid="ConnectWalletTestId">
      <div className="h-full flex flex-col justify-center">
        <div className="text-2xl text-[#010013] font-semibold">
          In order to check your <br />
          status, please connect your Wallet.
        </div>
        <button
          onClick={toggleWalletModal}
          className="w-52 h-11 min-h-[2.75rem] mt-6 rounded-md bg-gradient-to-r from-[#0666EA] to-[#FB71AE] text-[#FDFDFD] focus:outline-0"
          data-testid="ConnectWalletButton">
          <p className="flex-auto text-center text-base font-medium">Connect Wallet</p>
        </button>
      </div>
    </div>
  )
}

export default ConnectWallet
